import { useState } from "react";
import MultiInput from "components/input/multi";
import { Button } from "components/button";
import { useMutation, useQuery, useQueryClient } from "react-query";
import axios from "axios";
import { useModalContext } from "components/modal";
import { useTranslation } from "react-i18next";
import { useSnackbarContext } from "components/snackbar";

interface IProps {
  invoiceId: string;
  tr: (key: string) => string;
  customerEmails: string[];
  setCustomerEmails: (emails: string[]) => void;
}

const SendReceiptModal = ({ invoiceId, tr, customerEmails, setCustomerEmails }: IProps) => {
  const snackBar = useSnackbarContext();
  const queryClient = useQueryClient();
  const modal = useModalContext();

  const sendInvoiceReceipt = useMutation(
    async (emails: string[]) => await axios
      .post(`${process.env.REACT_APP_SERVER_URL}/api/v1/company/invoice/${invoiceId}/send-receipt`, {
        emails,
      })
      .then((res) => res.data),
    {
      onSuccess: () => {
        modal.setModal();
        queryClient.invalidateQueries();
        snackBar.showSnackbar(tr("Invoice receipt sent!"));
      },
    }
  );

  const [localEmails, setLocalEmails] = useState(customerEmails);
  const [sending, setSending] = useState(false);

  const handleSend = async () => {
    setSending(true);
    await sendInvoiceReceipt.mutateAsync(localEmails);
    setSending(false);
  };

  return (
    <>
      <div className="max-w-[400px]">
        <MultiInput
          values={localEmails}
          onChange={(values) =>
            setLocalEmails(values.filter((email): email is string => email !== null))
          }
        />
      </div>
      <div className="flex justify-end space-x-4 mt-4">
        <Button
          onClick={() => {
            modal.setModal();
            setCustomerEmails([]);
          }}
        >
          {tr("Cancel")}
        </Button>
        <Button
          primary
          onClick={handleSend}
          isLoading={sending || sendInvoiceReceipt.isLoading}
          disabled={sending || sendInvoiceReceipt.isLoading}
        >
          {tr("Send Receipt to Customer")}
        </Button>
      </div>
    </>
  );
};

export default SendReceiptModal;